import { WebappRoutes } from "@/shared/lib/webapp-routes"
import { useCallback } from "react"
import { useNavigate } from "@tanstack/react-router"

import { useChat } from "@/features/chat"
import { AdvisorAdsCard, advisorsList } from "@/features/advisors"

import { ADVISOR_PRESETS } from "../../config/advisor-presets"

const DEFAULT_MESSAGE =
  "Let’s see how your biorhythms flow today. What shall we explore: body, mind, or heart?"

/** Advisor promo block for deeper biorhythm interpretation. */
export function YourRhythmDecoded() {
  const navigate = useNavigate()
  const { setSelectedAdvisor, setPreSelectedChatMessage } = useChat()

  const handleChatWithAdvisor = useCallback(
    (message: string) => {
      setPreSelectedChatMessage(message)
      setSelectedAdvisor(advisorsList[7])
      navigate({ to: WebappRoutes.READINGS })
    },
    [navigate, setPreSelectedChatMessage, setSelectedAdvisor],
  )

  return (
    <div className="px-4">
      <h2 className="mb-2 mt-10 font-display text-2xl font-medium text-purple-light">
        Your rhythm, decoded
      </h2>
      <p className="mb-6 font-body text-base text-purple-light/70">
        Energy, emotions, clarity - see how today's inner cycles align. Pick the area you want to
        explore deeper.
      </p>
      <AdvisorAdsCard
        advisor={advisorsList[7]}
        message={DEFAULT_MESSAGE}
        presets={[...ADVISOR_PRESETS.biorhythm]}
        onPresetClick={handleChatWithAdvisor}
      />
    </div>
  )
}
